import React from 'react';
import Loadable from 'react-loadable';
import { Redirect, Route, Switch } from 'react-router-dom';
import EditableRoute from '@components/EditableRoute';

import EventsPageWrapper from './components/PageWrapper';

const Loading = () => <div />;

const EventSearch = Loadable({
  loader: () => import('./pages/search'),
  loading: Loading,
});
const EventDetail = Loadable({
  loader: () => import('./pages/eventDetail'),
  loading: Loading,
});
const EventQuickEntry = Loadable({
  loader: () => import('./pages/eventQuickEntry'),
  loading: Loading,
});
const EventForms = Loadable({
  loader: () => import('./pages/forms'),
  loading: Loading,
});
const FormDetail = Loadable({
  loader: () => import('./pages/formDetail'),
  loading: Loading,
});
const EventRoles = Loadable({
  loader: () => import('./pages/roles'),
  loading: Loading,
});
const EventRoleAssoc = Loadable({
  loader: () => import('./pages/roleAssoc'),
  loading: Loading,
});
const EventCodeFile = Loadable({
  loader: () => import('./pages/appSettings/codeFile'),
  loading: Loading,
});
const EventSmartLists = Loadable({
  loader: () => import('../appraisal/pages/smartListLauncher'),
  loading: Loading,
});

export const EventsRoute = {
  EventSearch: '/events/search',
  EventCreate: '/events/create',
  EventQuickEntry: '/events/quick-entry',
  EventDetail: '/events/edit/:eventID',
  EventForms: '/events/form',
  EventFormCreate: '/events/form/create',
  EventFormDetail: '/events/form/edit/:formID',
  EventRoles: '/events/roles/:roleID?',
  EventRoleAssoc: '/events/roles/:roleID',
  EventCodeFile: '/events/codefile',
  EventSmartLists: '/events/smart-lists',
};

const EventsRoutes = props => (
  <EventsPageWrapper {...props}>
    <Switch>
      <EditableRoute
        component={EventSearch}
        exact
        path={EventsRoute.EventSearch}
      />
      <EditableRoute
        component={EventDetail}
        exact
        path={EventsRoute.EventCreate}
      />
      <EditableRoute
        component={EventQuickEntry}
        exact
        path={EventsRoute.EventQuickEntry}
      />
      <EditableRoute
        component={EventDetail}
        exact
        path={EventsRoute.EventDetail}
      />

      <EditableRoute
        component={EventForms}
        exact
        path={EventsRoute.EventForms}
      />
      <EditableRoute
        component={FormDetail}
        exact
        path={EventsRoute.EventFormCreate}
      />
      <EditableRoute
        component={FormDetail}
        exact
        path={EventsRoute.EventFormDetail}
      />
      <EditableRoute
        component={EventCodeFile}
        exact
        path={EventsRoute.EventCodeFile}
      />

      <EditableRoute
        component={EventSmartLists}
        exact
        path={EventsRoute.EventSmartLists}
      />

      <Route
        path={EventsRoute.EventRoles}
        render={roleProps => (
          <EventRoles {...roleProps}>
            <Switch>
              <EditableRoute
                component={EventRoleAssoc}
                exact
                path={EventsRoute.EventRoleAssoc}
              />
            </Switch>
          </EventRoles>
        )}
      />

      <Redirect to={EventsRoute.EventSearch} />
    </Switch>
  </EventsPageWrapper>
);

export default EventsRoutes;
